import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const RemoveButtonContainer = styled.div`
  color: ${colors.koalaGrey};
  text-align: center;
`;

const RemoveTrashSign = styled.i`
  &:after {
    content: "\f014";
    font-family: FontAwesome;
    font-size: 18px;
    font-style: normal;
  }
`;

const RemoveButton = styled.div`
  cursor: pointer;
  margin-top: 5px;
`;

RemoveButton.displayName = "RemoveButton";
RemoveTrashSign.displayName = "RemoveTrashSign";
RemoveButtonContainer.displayName = "RemoveButtonContainer";

export { RemoveButton, RemoveTrashSign, RemoveButtonContainer };
